export default __webpack_public_path__ + "static/media/login.0d3e5831.svg";